// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__25uto","left":"StickyBox_left__3EGhx","right":"StickyBox_right__dRqOi"};